import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Bar, Button, BusyIndicator } from "@ui5/webcomponents-react";
import ManualForm from "./ManualForm";
import SocioeconomicForm from "./SocioeconomicForm";
import SocioeconomicForm2 from "./SocioeconomicForm2";
import SocioeconomicForm3 from "./SocioeconomicForm3";
import SocioeconomicForm4 from "./SocioeconomicForm4";
import SocioeconomicForm5 from "./SocioeconomicForm5";
import SocioeconomicForm6 from "./SocioeconomicForm6";
import SocioeconomicForm7 from "./SocioeconomicForm7";
import EnvironmentSanitationForm from "./EnvironmentSanitationForm";
import FamilyDemographic from "./FamilyDemographic";
import LastPage from "./LastPage";
import MassUploadManager from './MassUploadManager';
import UserMaintenance from "./UserMaintenance";
import { TabContainer, Tab } from "@ui5/webcomponents-react";
import UIModel from "../models/UIModel.json";
import merge from 'lodash/merge';
import localforage from 'localforage';

const TOTAL_STEPS = 11;

// Default health data structure matching FamilyDemographic.js
const defaultHealthDataForMerge = {
  G17: {
    BCG: { received: false, atBirth: false },
    HepatitisB: { received: false, atBirth: false },
    Pentavalent: { received: false, '1.5mos': false, '2.5mos': false, '3.5mos': false },
    OPV: { received: false, '1.5mos': false, '2.5mos': false, '3.5mos': false },
    IPV: { received: false },
    Pneumococcal: { received: false, '1.5mos': false, '2.5mos': false, '3.5mos': false },
    MMR: { received: false, '9mos': false, '1year': false },
    Other: { received: false, specify: '' }
  },
  G18: { status: '', date: '' },
  G19: {
    VitaminA: { received: false, date: '' },
    Iron: { received: false, date: '' },
    MNP: { received: false },
    IronFortifiedRice: { received: false },
    IodizedSalt: { received: false, source: '', sourceOther: '' }
  },
  G20: {
    Month1: false, Month2: false, Month3: false, Month4: false, Month5: false, Month6: false,
    DateLastBreastfed: ''
  },
  G21: '',
};

// Initial form data structure - updated keys for agriculture/fisheries
const initialFormData = {
  householdType: "Family",
  longitude: "",
  latitude: "",
  houseNo: "",
  street: "",
  purokSitio: "",
  barangay: "",
  cityMunicipality: "",
  province: "",
  municipality: "",
  firstName: "",
  middleName: "",
  lastName: "",
  suffix: "",
  familyType: "Main Family (Owner)",
  headID: "",
  status: "Active",
  causeOfDeath: "",
  sex: "",
  gender: "",
  civilStatus: "",
  numFamilyMembers: "",
  yearMoved: "",
  prevLocation: "",
  mobileProvider: ["", "", ""],
  contactNumber: ["", "", ""],
  internetProvider: "",
  internetProviderOther: "",
  householdAppliances: {},
  ictDevices: {},
  vehicles: {},
  lotOwnership: "",
  houseOwnership: "",
  lotOwnershipOther: "",
  houseOwnershipOther: "",
  cultivatedLand: [],
  agriculturalProducts: [],
  agriculturalMachineries: [],
  animalsRaised: [],
  petAnimals: [],
  fisheriesEntries: [],
  boatEntries: [],
  nipaEntries: [],
  fishingGearEntries: [],
  environmentSanitation: {
    selectedWaterSource: [],
    selectedWaterLocation: "",
    isWaterAvailable: "",
    selectedWaterSource2: [],
    selectedWaterLocation2: "",
    isWaterAvailable2: "",
    selectedToiletFacility: [],
    selectedToiletLocation: "",
    toiletSharing: "",
    selectedGarbageDisposal: [],
  },
  familyMembers: [],
  familyDemographics: [{
    firstName: "",
    middleName: "",
    lastName: "",
    relationship: "HH Head",
    status: "Present Member",
    sex: "",
    gender: "",
    birthdate: "",
    withSeniorId: "",
    seniorCitizenIdNo: "",
    birthPlace: "",
    citizenship: "Philippines",
    migrationStatus: "",
    registeredVoter: "",
    civilStatus: "",
    soloParentId: "",
    religion: "",
    skills: [],
    organizations: "",
    ethnicity: "",
    schoolingStatus: "",
    schoolingReasons: [],
    schoolName: "",
    educationalAttainment: [],
    degree: ""
  }],
  lastPageData: {
    foodSecurity: {},
    socialProtection: { I1: [], I2: [] },
    peaceAndOrder: {
      J1: "",
      J2: "",
      J3: "",
      J4: ""
    }
  },
  houseStructure: "",
  houseStructureOther: "",
  externalHouseWall: "",
  externalHouseWallOther: "",
  roofingMat: "",
  roofingMatOther: "",
  floorMat: "",
  floorMatOther: "",
  sourceElect: "",
  sourceElectOther: "",
  cookingFac: "",
  cookingFacOther: "", 
  assistanceSourceOther: "",
  assistanceTypeOther: "",
  disasterImpactOther: "",
  disasterTypeOther: "",
  experiencedDisaster: "",
  evacuationAreaOther: "",
};

const SyncNotification = ({ syncedData, setSyncedData }) => {
  const [expanded, setExpanded] = useState(false);

  const successList = syncedData?.filter(item => item.headId !== null) || [];
  const failList = syncedData?.filter(item => item.headId === null) || [];

  return (
    <div
      style={{
        position: "fixed",
        top: "60px",
        right: "20px",
        backgroundColor: "#1e293b", // dark slate background
        color: "#fff",
        padding: "12px 16px",
        borderRadius: "10px",
        boxShadow: "0 2px 10px rgba(0,0,0,0.3)",
        zIndex: 9999,
        fontSize: "14px",
        width: expanded ? "300px" : "240px",
        transition: "all 0.3s ease-in-out",
      }}
    >
      {/* Header Section */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span style={{ fontWeight: 600 }}>✅ Sync Complete</span>

        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          {/* Expand/Collapse button */}
          <button
            onClick={() => setExpanded(!expanded)}
            style={{
              background: "none",
              border: "none",
              color: "#fff",
              fontSize: "16px",
              cursor: "pointer",
              transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 0.2s ease",
            }}
            title={expanded ? "Collapse details" : "Expand details"}
          >
            ▼
          </button>

          {/* Close button */}
          <button
            onClick={() => setSyncedData([])}
            style={{
              background: "none",
              border: "none",
              color: "#fff",
              fontSize: "16px",
              cursor: "pointer",
              lineHeight: "1",
              padding: "0 4px",
            }}
            title="Close notification"
          >
            ×
          </button>
        </div>
      </div>

      {/* Expanded Details */}
      <div
        style={{
          maxHeight: expanded ? "180px" : "0",
          overflow: "hidden",
          transition: "max-height 0.3s ease",
          marginTop: expanded ? "8px" : "0",
        }}
      >
        <div
          style={{
            backgroundColor: "#334155",
            borderRadius: "8px",
            padding: "8px 10px",
          }}
        >
          {/* Success Section */}
          <p style={{ margin: "6px 0 2px", fontWeight: 600, color: "#86efac" }}>
            Synced Successfully
          </p>
          {successList.length > 0 ? (
            <ul style={{ margin: "4px 0 10px 15px", padding: 0, fontSize: "13px" }}>
              {successList.map((item, i) => (
                <div key={i} style={{display: "flex", justifyContent: "space-between"}}>
                  <span>{item.headId}</span>
                  <span>{item.headName}</span>
                </div>
              ))}
            </ul>
          ) : (
            <p style={{ fontSize: "13px", color: "#9ca3af" }}>No successful syncs</p>
          )}

          {/* Failed Section */}
          <p style={{ margin: "6px 0 2px", fontWeight: 600, color: "#fca5a5" }}>
            Failed to Sync
          </p>
          {failList.length > 0 ? (
            <ul style={{ margin: "4px 0 0 15px", padding: 0, fontSize: "13px" }}>
              {failList.map((item, i) => (
                <li key={i}>{item.headName}</li>
              ))}
            </ul>
          ) : (
            <p style={{ fontSize: "13px", color: "#9ca3af" }}>No failed syncs</p>
          )}
        </div>
      </div>
    </div>
  );
}

const MainFormContainer = ({ cityList, userRole: propUserRole }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [userRole, setUserRole] = useState(() => {
    const storedRole = localStorage.getItem("userRole");
    const parsedRole = storedRole ? parseInt(storedRole, 10) : null;
    const initialRole = propUserRole || location.state?.role || parsedRole || 0; // Default to 0 if all are null
    console.debug("Initializing userRole:", { propUserRole, locationStateRole: location.state?.role, storedRole, parsedRole, initialRole });
    return initialRole;
  });

  const [isBusy, setIsBusy] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [activeTab, setActiveTab] = useState("Manual Entry");
  const [syncing, setSyncing] = useState(false);
  const [syncedData, setSyncedData] = useState([]);
  const tabContainerRef = useRef(null);

  useEffect(() => {
    // Save userRole to localStorage whenever it changes
    if (userRole !== null) {
      console.debug("Saving userRole to localStorage:", userRole);
      localStorage.setItem("userRole", userRole.toString()); // Ensure it's stored as a string
    }
  }, [userRole]);

  useEffect(() => {
    // Redirect to login if userRole is not set
    if (!userRole) {
      console.debug("Redirecting to login due to missing userRole");
      navigate("/login", { replace: true });
    }
  }, [userRole, navigate]);

  // Debugging userRole before rendering
  useEffect(() => {
    console.debug("Rendering with userRole:", userRole);
  }, [userRole]);

  // Initialize form data - Ensure deep merge for G17-G20 in existing members
  const [formData, setFormData] = useState(() => {
    const savedData = localStorage.getItem("draftFormData");
    let parsedData = savedData ? JSON.parse(savedData) : initialFormData;
    if (parsedData.healthNutrition) {
      delete parsedData.healthNutrition;
    }
    parsedData.cultivatedLand = parsedData.cultivatedLand || [];
    parsedData.agriculturalProducts = parsedData.agriculturalProducts || [];
    parsedData.agriculturalMachineries = parsedData.agriculturalMachineries || [];
    parsedData.animalsRaised = parsedData.animalsRaised || [];
    parsedData.petAnimals = parsedData.petAnimals || [];
    parsedData.fisheriesEntries = parsedData.fisheriesEntries || [];
    parsedData.boatEntries = parsedData.boatEntries || [];
    parsedData.nipaEntries = parsedData.nipaEntries || [];
    parsedData.fishingGearEntries = parsedData.fishingGearEntries || [];
    parsedData.familyMembers = (parsedData.familyMembers || []).map(member => {
      // Deep merge default G17-G21 structure with member's data
      const memberWithDefaults = merge({}, defaultHealthDataForMerge, member); // Deep merge G17-G21

      return {
        ...member, // Spread original member data first
        ...memberWithDefaults, // Spread merged data (overwrites G17-G21)
        withSeniorId: member.withSeniorId || "",
        seniorCitizenIdNo: member.seniorCitizenIdNo || ""
      };
    });
    parsedData.familyDemographics = (parsedData.familyDemographics || []).map(demo => ({
      ...demo,
      withSeniorId: demo.withSeniorId || "",
      seniorCitizenIdNo: demo.seniorCitizenIdNo || ""
    }));
    if (!parsedData.familyDemographics || parsedData.familyDemographics.length === 0) {
      parsedData.familyDemographics = [initialFormData.familyDemographics[0]];
    }
    parsedData.environmentSanitation = parsedData.environmentSanitation || initialFormData.environmentSanitation;
    parsedData.lastPageData = parsedData.lastPageData || initialFormData.lastPageData;
    return parsedData;
  });

  // Save form data to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem("draftFormData", JSON.stringify(formData));
  }, [formData]);

  // Handle form field changes (modified to handle batch and array updates)
  const handleFormChange = useCallback((field, value, index = null) => {
    setFormData(prev => {
      // console.log('----------Debug: MainForm--------')
      // console.log('field:',field)
      // console.log('value:',value)
      // Handle batch updates
      if (value === "batchUpdate" && typeof field === 'object' && field !== null) {
        return { ...prev, ...field };
      }

      if(value === "familyMembers"){
        return { ...prev, [value]: field };
      }
      // Handle specific location fields clearing dependencies
      if (field === "province" || field === "municipality" || field === "barangay" || field === "cityMunicipality") {
        if (field === "province") {
          return { ...prev, province: value, municipality: "", barangay: "", cityMunicipality: "" };
        }
        if (field === "municipality") {
          return { ...prev, municipality: value, barangay: "" };
        }
        if (field === "cityMunicipality") {
          return { ...prev, cityMunicipality: value, barangay: "" };
        }
        // Fallthrough for barangay or if none of the above matched
        return { ...prev, [field]: value };
      }

      // Handle 'all' update (used for loading drafts/resetting)
      if (field === "all") {
        return value;
      }

      // Handle indexed updates (e.g., mobileProvider[0])
      if (index !== null) {
        // Specific handling for mobileProvider/contactNumber which are fixed-size arrays
        if (field === "mobileProvider" || field === "contactNumber") {
          const currentArray = Array.isArray(prev[field]) ? prev[field] : ["", "", ""];
          const newArray = [...currentArray];
          newArray[index] = value;
          return { ...prev, [field]: newArray };
        }
        // Generic handling for indexed updates in other arrays (if needed, though less common now)
        if (Array.isArray(prev[field])) {
            return {
              ...prev,
              [field]: prev[field].map((item, i) => (i === index ? value : item))
            };
        }
        // If not an array, maybe log an error or handle differently
        console.warn(`Indexed update attempted on non-array field: ${field}`);
        return prev;
      }

      // Handle direct field updates (including arrays like familyMembers, familyDemographics)
      // This now covers the cases previously handled by handleArrayFormChange
      return { ...prev, [field]: value };
    });
  }, []);

  // Validation function for ManualForm.js
  const validateManualForm = () => {
    const requiredFields = ["province", "cityMunicipality", "barangay", "firstName", "lastName", "numFamilyMembers"];
    for (const field of requiredFields) {
      if (!formData[field] || formData[field].trim() === "") {
        alert(`Please fill in the required field: ${field.replace(/([A-Z])/g, " $1")}`);
        return false;
      }
    }
    return true;
  };
  const validateFamilyDemographic = () => {
    const headDemographics = formData.familyDemographics && formData.familyDemographics.length > 0
        ? formData.familyDemographics[0]
        : {};
    const requiredFields = ["sex", "status", "birthdate"];
    for (const field of requiredFields) {
      //console.log(formData.familyDemographics)
      if (!headDemographics[field] || headDemographics[field].trim() === "") {
        alert(`Please fill in the required field: ${field.replace(/([A-Z])/g, " $1")}`);
        return false;
      }
    }
    return true;
  };

  // Navigation handlers
  const handleNext = useCallback(() => {
    if (currentStep === 1 && !validateManualForm()) {
      return; // Stop navigation if validation fails
    }
    if (currentStep === 10 && !validateFamilyDemographic()) {
      return; // Stop navigation if validation fails
    }
    if (currentStep < TOTAL_STEPS) {
      setCurrentStep(prev => prev + 1);
    }
  }, [currentStep, formData]);

  const handlePrevious = useCallback(() => {
    setCurrentStep(prev => prev - 1);
  }, []);

  // Format date for API
  const formatDate = useCallback((input) => {
    if (!input) return null;
    const d = new Date(input);
    if (isNaN(d)) return null;
    const pad = (n) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  }, []);

  // Handle form submission
  const handleSave = useCallback(async () => {
    // Validate UIModel.payload before proceeding
    if (!UIModel || typeof UIModel.payload !== 'object' || UIModel.payload === null) {
      console.error("Error: UIModel.payload is not a valid object.", UIModel);
      alert("Critical error: Payload template is missing or invalid. Cannot save data.");
      return; // Stop the submission
    }

    setIsBusy(true);
    try {
      // Ensure familyDemographics exists and has at least one member (the head)
      const headDemographics = formData.familyDemographics && formData.familyDemographics.length > 0
        ? formData.familyDemographics[0]
        : {}; // Provide an empty object as fallback, though initial state should prevent this

      // --- ASSET PAYLOAD TRANSFORMATION START ---
      // Helper to map asset objects to array of {type, name, quantity}
      const mapAssets = (assetObj, assetType, items) => {
        if (!assetObj) return [];
        return Object.entries(assetObj)
          .filter(([number, qty]) => Number(qty) > 0)
          .map(([number, qty]) => {
            const found = items.find(i => String(i.number) === String(number));
            return {
              asset_type: assetType,
              asset_name: found ? found.label : String(number),
              quantity: Number(qty)
            };
          });
      };

      // Get asset items from UIModel
      const applianceItems = [
        { number: 1, label: "Refrigerator" },
        { number: 2, label: "Washing Machine" },
        { number: 3, label: "Electric Fan" },
        { number: 4, label: "Air Conditioner" },
        { number: 5, label: "Rice Cooker" },
        { number: 6, label: "Microwave Oven" },
        { number: 7, label: "Gas Stove" },
        { number: 8, label: "Electric Stove" },
        { number: 9, label: "Blender" },
        { number: 10, label: "Water Dispenser" },
        { number: 11, label: "Vacuum Cleaner" },
        { number: 12, label: "Sewing Machine" },
        { number: 13, label: "Flat Iron" },
        { number: 14, label: "Oven Toaster" },
        { number: 15, label: "Others" }
      ];
      const vehicleItems = [
        { number: 1, label: "Car" },
        { number: 2, label: "Motorcycle" },
        { number: 3, label: "Bicycle" },
        { number: 4, label: "Tricycle" },
        { number: 5, label: "Boat" },
        { number: 6, label: "Truck" },
        { number: 7, label: "Others" }
      ];
      // ICT items are a subset of applianceItems by number (match SocioeconomicForm.js: 1-6)
      const ictNumbers = [1,2,3,4,5,6]; 
      const ictItems = [
        { number: 1, label: "Radio/Tape recorder/Stereo" },
        { number: 2, label: "Television (TV)" },
        { number: 3, label: "VCR/Karaoke/Videoke" },
        { number: 4, label: "Video Games" },
        { number: 5, label: "Computer/Laptop" },
        { number: 6, label: "Printer" },
        { number: 7, label: "CD/VCD/DVD Player" },
        { number: 8, label: "Telephone" },
        { number: 9, label: "Mobile Phone" },
        { number: 10, label: "Tablet" },
      ];

      // Compose all assets into a single array
      const filteredOtherHouseholdAppliances = Object.fromEntries(Object.entries((formData.householdAppliancesOthers || {})).filter(([key, value]) => value.name !== '' && value.quantity > 0));
      const otherHouseholdAppliances = Object.entries((filteredOtherHouseholdAppliances || {})).reduce((acc, [_, { name, quantity }]) => {
        if (name) acc[name] = quantity;  // skip empty names
        return acc;
      }, {});
      const allHouseholdAppliances = {...(formData.householdAppliances || {}), ...otherHouseholdAppliances}
      const householdApplianceAssets = mapAssets(allHouseholdAppliances, "Appliance", applianceItems);

      const filteredOtherictAssets = Object.fromEntries(Object.entries((formData.ictDevicesOthers || {})).filter(([key, value]) => value.name !== '' && value.quantity > 0));
      const otherIctAssets = Object.entries((filteredOtherictAssets || {})).reduce((acc, [_, { name, quantity }]) => {
        if (name) acc[name] = quantity;  // skip empty names
        return acc;
      }, {});
      const allIctAssets = {...(formData.ictDevices || {}), ...otherIctAssets}
      const ictAssets = mapAssets(allIctAssets, "ICT", ictItems);

      const filteredOtherVehicles = Object.fromEntries(Object.entries((formData.vehiclesOthers || {})).filter(([key, value]) => value.name !== '' && value.quantity > 0));
      const otherVehicles = Object.entries((filteredOtherVehicles || {})).reduce((acc, [_, { name, quantity }]) => {
        if (name) acc[name] = quantity;  // skip empty names
        return acc;
      }, {});
      const allVehicles = {...(formData.vehicles || {}), ...otherVehicles}
      const vehicleAssets = mapAssets(allVehicles, "Vehicle", vehicleItems);
      // Compose all assets into a single array
      const householdAssets = [
        ...householdApplianceAssets,
        ...ictAssets,
        ...vehicleAssets
      ];
      // --- ASSET PAYLOAD TRANSFORMATION END ---

      // NEW: Build senderId from userRole + userId (both from localStorage/state)
      const storedUserId = localStorage.getItem("userId");
      const payloadTemplate = JSON.parse(JSON.stringify(UIModel.payload));
      const payload = {
        ...payloadTemplate,
        // NEW FIELD
        senderId: storedUserId,
        // Use head's name from top-level formData (assuming ManualForm sets these)
        firstName: formData.firstName,
        middleName: formData.middleName,
        lastName: formData.lastName,
        suffix: formData.suffix,
        familyType: formData.familyType,
        headID: formData.headID, // extended_head_id
        // Use head's demographic details from familyDemographics[0]
        birthdate: formatDate(headDemographics.birthdate),
        birthPlace: headDemographics.birthPlace,
        citizenship: headDemographics.citizenship,
        // Revert to sending the full string value for sex
        sex: headDemographics.sex || null,
        gender: headDemographics.gender, // Assuming backend handles the full string or needs similar adjustment
        civilStatus: headDemographics.civilStatus, // Assuming backend handles the full string or needs similar adjustment
        // Address details from top-level formData
        houseNo: formData.houseNo,
        street: formData.street,
        purokSitio: formData.purokSitio,
        barangay: formData.barangay,
        cityMunicipality: formData.cityMunicipality,
        province: formData.province,
        latitude: parseFloat(formData.latitude) || null,
        longitude: parseFloat(formData.longitude) || null,
        // Other fields from top-level formData
        numFamilyMembers: parseInt(formData.numFamilyMembers),
        yearMoved: formData.yearMoved,
        prevLocation: formData.prevLocation,
        mobileProvider: formData.mobileProvider,
        contactNumber: formData.contactNumber,
        internetProvider: formData.internetProvider,
        internetProviderOther: formData.internetProviderOther,
        householdAppliances: allHouseholdAppliances, 
        ictDevices: allIctAssets,  
        vehicles: allVehicles, 
        householdAssets, // <-- NEW FIELD for backend
        lotOwnership: formData.lotOwnership?.value ?? formData.lotOwnership ?? "",
        lotOwnershipType: formData.lotOwnership?.type ?? "",
        houseOwnership: formData.houseOwnership?.value ?? formData.houseOwnership ?? "",
        houseOwnershipType: formData.houseOwnership?.type ?? "",
        lotOwnershipOther: formData.lotOwnershipOther,
        houseOwnershipOther: formData.houseOwnershipOther,
        houseStructure: formData.houseStructure?.value ?? formData.houseStructure ?? "",
        houseStructureType: formData.houseStructure?.type ?? "",
        houseStructureOther: formData.houseStructureOther,
        externalHouseWall: formData.externalHouseWall?.value ?? formData.externalHouseWall ?? "",
        externalHouseWallType: formData.externalHouseWall?.type ?? "",
        externalHouseWallOther: formData.externalHouseWallOther,
        roofingMat: formData.roofingMat?.value ?? formData.roofingMat ?? "",
        roofingMatType: formData.roofingMat?.type ?? "",
        roofingMatOther: formData.roofingMatOther,
        floorMat: formData.floorMat?.value ?? formData.floorMat ?? "",
        floorMatType: formData.floorMat?.type ?? "",
        floorMatOther: formData.floorMatOther,
        sourceElect: formData.sourceElect?.value ?? formData.sourceElect ?? "",
        sourceElectType: formData.sourceElect?.type ?? "",
        sourceElectOther: formData.sourceElectOther,
        cookingFac: formData.cookingFac?.value ?? formData.cookingFac ?? "",
        cookingFacType: formData.cookingFac?.type ?? "",
        cookingFacOther: formData.cookingFacOther,

        // Map cultivatedLand fields to match the database schema
        cultivatedLand: formData.cultivatedLand,
        agriculturalProducts: formData.agriculturalProducts,
        agriculturalMachineries: formData.agriculturalMachineries,
        animalsRaised: formData.animalsRaised,
        petAnimals: formData.petAnimals,
        fisheriesEntries: formData.fisheriesEntries,
        boatEntries: formData.boatEntries,
        nipaEntries: formData.nipaEntries,
        fishingGearEntries: formData.fishingGearEntries,
        environmentSanitation: formData.environmentSanitation,
        // Add Step 4: Disaster Risk Reduction and Management fields
        houseExtension: formData.houseExtension,
        houseExtensionOther: formData.houseExtensionOther,
        wallThickness: formData.wallThickness,
        wallThicknessOther: formData.wallThicknessOther,
        steelStandard: formData.steelStandard,
        steelStandardOther: formData.steelStandardOther,
        wallSupport: formData.wallSupport,
        wallSupportOther: formData.wallSupportOther,
        gableWallMaterial: formData.gableWallMaterial,
        gableWallMaterialOther: formData.gableWallMaterialOther,
        foundationMaterial: formData.foundationMaterial,
        foundationMaterialOther: formData.foundationMaterialOther,
        soilCondition: formData.soilCondition,
        soilConditionOther: formData.soilConditionOther,
        houseCondition: formData.houseCondition,
        houseConditionOther: formData.houseConditionOther,
        houseLocation: formData.houseLocation,
        houseLocationOther: formData.houseLocationOther,
        ecologicalSetting: formData.ecologicalSetting,
        buildingPermit: formData.buildingPermit,
        houseBuiltBefore1990: formData.houseBuiltBefore1990,
        houseAffectedByDisaster: formData.houseAffectedByDisaster,
        houseShape: formData.houseShape,
        experiencedDisaster: formData.experiencedDisaster,
        disasterType: formData.disasterType,
        evacuationArea: formData.evacuationArea,
        disasterImpact: formData.disasterImpact,
        assistanceType: formData.assistanceType,
        assistanceSource: formData.assistanceSource,
        extraExperiencedDisaster: formData.extraExperiencedDisaster,
        // Map family members, including the new G17-G21 structures
        familyMembers: (formData.familyMembers || []).map((member) => {
          // Convert boolean-like strings to tinyint(1) compatible values (0 or 1)
          const isOfwValue = member.isOFW === "1 - Yes" ? 1 : (member.isOFW === "2 - No" ? 0 : null);
          const seekingWorkValue = member.seekingWork === "1 - Actively seeking" ? 1 : (member.seekingWork === "2 - Not actively seeking" ? 0 : null);
          const withSeniorIdValue = member.withSeniorId === "1 Yes" ? 1 : (member.withSeniorId === "2 No" ? 0 : null);

          // Prepare G17-G21 data for payload
          const g17Payload = member.G17 && typeof member.G17 === 'object' ? member.G17 : null;
          const g18Payload = member.G18 && typeof member.G18 === 'object'
            ? { ...member.G18, date: formatDate(member.G18.date) } // Format date
            : null;
          const g19Payload = member.G19 && typeof member.G19 === 'object'
            ? {
                ...member.G19,
                VitaminA: { ...member.G19.VitaminA, date: formatDate(member.G19.VitaminA?.date) }, // Format date
                Iron: { ...member.G19.Iron, date: formatDate(member.G19.Iron?.date) } // Format date
              }
            : null;
          const g20Payload = member.G20 && typeof member.G20 === 'object'
            ? { ...member.G20, DateLastBreastfed: formatDate(member.G20.DateLastBreastfed) } // Format date
            : null;
          const g21Payload = member.G21 || null; // G21 is just a string

          return {
            ...member, // Spread other member fields first
            sex: member.sex || null,
            skils: member.skills,
            birthdate: formatDate(member.birthdate),
            isOFW: isOfwValue,
            seekingWork: seekingWorkValue,
            with_senior_id: withSeniorIdValue,
            senior_citizen_id: member.seniorCitizenIdNo || null,
            G17: g17Payload, // Add the G17 object
            G18: g18Payload, // Add the G18 object (with formatted date)
            G19: g19Payload, // Add the G19 object (with formatted dates)
            G20: g20Payload, // Add the G20 object (with formatted date)
            G21: g21Payload, // Add the G21 string
            // Remove original fields if they are not expected by the backend
            withSeniorId: undefined,
            seniorCitizenIdNo: undefined,
          };
        }),
        lastPageData: formData.lastPageData,
        numFamilyMembers: formData.numFamilyMembers,
        yearMoved: formData.yearMoved,
        prevLocation: formData.prevLocation,
      };

      // Remove undefined fields before sending
      payload.familyMembers = payload.familyMembers.map(member => {
        Object.keys(member).forEach(key => member[key] === undefined && delete member[key]);
        return member;
      });

      

      // Add healthNutrition to payload if present
      if (formData.healthNutrition) {
        payload.healthNutrition = formData.healthNutrition;
      }
      const modifyPayload = (payload) => {
        const modifyCultivatedLand = payload.cultivatedLand.map(land => {
          const { municipalities, barangays, ...rest } = land;
          return rest;
        });
        const modifiedProducts = payload.agriculturalProducts.map(product => {
          const { municipalities, barangays, ...rest } = product;
          return rest;
        });
        const modifiedFisheries = payload.fisheriesEntries.map(entry => {
          const { municipalities, barangays, ...rest } = entry;
          return rest;
        });

        return { ...payload,
          cultivatedLand: modifyCultivatedLand,
          agriculturalProducts: modifiedProducts,
          fisheriesEntries: modifiedFisheries,
        };
      };
      const newPayload = modifyPayload(payload);
      // Debugging: Log the payload before sending
      // console.log("Payload being sent:", newPayload);


      // save locally
      if (!navigator.onLine) {
        await localforage.setItem(Date.now().toString(), newPayload);
        alert("Saved locally! It will sync when you're online.");
      } else {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/upload/mass-upload`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "x-api-key": process.env.REACT_APP_API_KEY,
            },
            body: JSON.stringify(newPayload),
          }
        );

        const result = await response.json();

        if (!response.ok) {
          console.error("Server error response:", result);
          throw new Error(result.message || `Failed to save data. Status: ${response.status}`);
        }

        alert(`Submission successful! Household ID: ${result.headId}`);
      }

      // reset survey form
      localStorage.removeItem("draftFormData");
      setFormData(initialFormData);
      setCurrentStep(1);
    } catch (error) {
      console.error("Error submitting data:", error);
      // Display a more informative error message
      alert(`Submission failed: ${error.message}. Please check the console for more details.`);
    } finally {
      setIsBusy(false);
    }
  }, [formData, formatDate, userRole]); // added userRole


  // post data when online
  useEffect(() => {
    const syncOfflineData = async () => {
      setSyncing(true);
      const keys = await localforage.keys();
      for (const key of keys) {
        if (key.startsWith('location')) {
          continue
        } 
        const data = await localforage.getItem(key);
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/upload/mass-upload`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "x-api-key": process.env.REACT_APP_API_KEY,
            },
            body: JSON.stringify(data),
          }
        );

        const result = await response.json();

        syncedData.push({
          headId: result.headId ? result.headId : null,
          headName: data.familyMembers[0].firstName + ' ' + data.familyMembers[0].lastName
        });
        await localforage.removeItem(key);
      }
      setSyncing(false);
    };

    window.addEventListener("online", syncOfflineData);
    return () => window.removeEventListener("online", syncOfflineData);
  }, []);

  // Tab change handler
  const handleTabSelect = useCallback((e) => {
    setActiveTab(e.detail.tab.dataset.tabId);
  }, []);

  return (
    <div style={{ position: "relative", minHeight: "100vh", paddingBottom: "60px" }}>
      {isBusy && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000
        }}>
          <BusyIndicator 
            active
            text="Saving data. Please wait..."
            style={{
              backgroundColor: 'white',
              padding: '1rem',
              borderRadius: '0.25rem'
            }}
          />
        </div>
      )}

      {syncing && (
        <div
          style={{
            position: "fixed",
            top: "60px",
            right: "20px",
            display: "flex",
            alignItems: "center",
            gap: "10px",
            background: "linear-gradient(135deg, #4F46E5, #6366F1)",
            color: "#fff",
            padding: "14px 22px",
            borderRadius: "12px",
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.25)",
            zIndex: 9999,
            fontSize: "15px",
            fontWeight: 500,
            opacity: 0.95,
            backdropFilter: "blur(6px)",
            transition: "all 0.3s ease-in-out",
            animation: "floatIn 0.3s ease-out",
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="feather feather-refresh-cw"
            style={{ animation: "spin 1.2s linear infinite" }}
          >
            <polyline points="23 4 23 10 17 10"></polyline>
            <polyline points="1 20 1 14 7 14"></polyline>
            <path d="M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15"></path>
          </svg>
          <span>Syncing offline data...</span>

          <style>
            {`
              @keyframes spin {
                from { transform: rotate(0deg); }
                to { transform: rotate(360deg); }
              }

              @keyframes floatIn {
                from {
                  opacity: 0;
                  transform: translateY(-10px);
                }
                to {
                  opacity: 1;
                  transform: translateY(0);
                }
              }
            `}
          </style>
        </div>
      )}

      {(!syncing && syncedData.length !== 0) && (
        <SyncNotification
          syncedData={syncedData}
          setSyncedData={setSyncedData}
        />
      )}

      {/* Render Manual Entry logic directly */}
      <>
        {currentStep === 1 && (
          <ManualForm
            formData={formData}
            onFormChange={handleFormChange}
            setFormData={setFormData}
            handleNext={handleNext}
          />
        )}
        {currentStep === 2 && <SocioeconomicForm formData={formData} onFormChange={handleFormChange} handlePrevious={handlePrevious} handleNext={handleNext} />}
        {currentStep === 3 && <SocioeconomicForm2 formData={formData} onFormChange={handleFormChange} handlePrevious={handlePrevious} handleNext={handleNext} />}
        {currentStep === 4 && <SocioeconomicForm3 formData={formData} onFormChange={handleFormChange} handlePrevious={handlePrevious} handleNext={handleNext} />}
        {currentStep === 5 && <SocioeconomicForm4 formData={formData} onFormChange={handleFormChange} handlePrevious={handlePrevious} handleNext={handleNext} />}
        {currentStep === 6 && <SocioeconomicForm5 formData={formData} onFormChange={handleFormChange} handlePrevious={handlePrevious} handleNext={handleNext} />}
        {currentStep === 7 && <SocioeconomicForm6 formData={formData} onFormChange={handleFormChange} handlePrevious={handlePrevious} handleNext={handleNext} />}
        {currentStep === 8 && <SocioeconomicForm7 formData={formData} onFormChange={handleFormChange} handlePrevious={handlePrevious} handleNext={handleNext} />}
        {currentStep === 9 && (
          <EnvironmentSanitationForm
            formData={formData.environmentSanitation || {}}
            onFormChange={(updatedData) => handleFormChange("environmentSanitation", updatedData)}
            handlePrevious={handlePrevious}
            handleNext={handleNext}
          />
        )}
        {currentStep === 10 && (
          <FamilyDemographic
            formData={formData}
            onFormChange={handleFormChange}
            handlePrevious={handlePrevious}
            handleNext={handleNext}
            cityList={cityList}
          />
        )}
        {currentStep === 11 && (
          <LastPage
            formData={formData}
            onFormChange={handleFormChange}
            handlePrevious={handlePrevious}
          />
        )}
      </>

      {/* Navigation buttons */}
      <div
        style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          display: "flex",
          justifyContent: currentStep > 1 ? "space-between" : "flex-end",
          padding: "16px",
          backgroundColor: "#fff",
          borderTop: "1px solid #d9d9d9",
          boxShadow: "0 -2px 8px rgba(0,0,0,0.08)",
          zIndex: 100
        }}
      >
        {currentStep > 1 && (
          <Button design="Transparent" onClick={handlePrevious}>
            Previous
          </Button>
        )}
        {currentStep < TOTAL_STEPS ? (
          <Button design="Emphasized" onClick={handleNext}>
            Next
          </Button>
        ) : (
          <Button design="Positive" onClick={handleSave}>
            Submit
          </Button>
        )}
      </div>
    </div>
  );
};

export default MainFormContainer;